exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button {\n  color: #fff;\n  background: #6d6d6d;\n  border: none;\n  border-radius: 0.286em;\n  white-space: nowrap;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation; }\n\nbutton:hover {\n  background: #007BB9;\n  color: #fff; }\n\n.btn {\n  font-size: 14px;\n  line-height: 20px;\n  padding: 2px 8px 2px 5px; }\n\n.btn span.ico {\n  font-size: 20px;\n  vertical-align: middle; }\n\n.large-btn {\n  font-size: 18px;\n  font-weight: 600;\n  padding: 10px 62px; }\n  .large-btn span.ico {\n    font-size: 16px;\n    vertical-align: middle; }\n\n.text-only-btn {\n  padding: 6px 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/tg-button/tg-button.component.scss
// module id = ../../../../../src/app/core/components/tg-button/tg-button.component.scss
// module chunks = main